/**
 * Column widths shared by the task-list HEADER and the task ROW.
 *
 * They live here because they must be identical in two files that render
 * independently — `g-task-list` draws the heading strip, `g-task-item` draws
 * each row — and a header that does not line up with what is under it is worse
 * than no header at all: it labels the wrong column with total confidence.
 *
 * Tailwind classes rather than numbers, because the row already lays out with
 * flex utilities and a pixel width here would have to be kept in step with them
 * by hand.
 */

/** Each configured pill (status, owner, priority…) gets one cell this wide. */
export const PILL_COL = 'w-32';

/** The due-date cell, right-aligned at the end of the row. */
export const DUE_COL = 'w-28';

/** Leading cells before the title: the drag grip, then the checkbox. */
export const LEAD_COLS = ['w-4', 'w-5'];
